export const API_URL = "https://api.moraghebbime.com";

export const HOME_URL = "https://moraghebbime.com";
